

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import S from '../../pages/SingleDam.module.css'
import E from '../../pages/ListDam.module.css'
import W from '../../pages/ListDam.module.css'

import {  Home, Sensors } from '@mui/icons-material'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useEffect, useState } from 'react'

import InfoIcon from '@mui/icons-material/Info';


import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import EmptyReturn from '../EmptyReturn';
import TerminalList from '../cardThemes/TerminalList'
import apiService from '../../api/ApiService';
import { addTerminalList } from '../../redux/slices/adminSlice';
import useChangeFarm from '../CustomHooks/useChangeFarm';
const moment=require('moment-jalaali');

const a=[
    {comp:'فعال'},{comp:'غیر فعال'}
  ]
const TerminalsComp=()=>{
    const [Value,setValue]=useState(0)
    const {pathname}=useLocation()
    console.log(pathname)
    const {currentAdmin,currentTerminals,currentTheme}=useSelector(state=>state.p.admin)
    const {changeFarm}=useChangeFarm()
    const dispatch=useDispatch()
    const getTerminals=async()=>{
        const data=JSON.stringify({
            "skip": -1,
            "take": -1,
            "fromDate": null,
            "toDate": null,
            "isActive":Value==0?true:false,
            "farmIds":pathname!=='/AllFarmsAdmin'?[currentAdmin.id]:null
        })
            const res=await apiService.getTerminals(data)
            
            dispatch(addTerminalList(res.data.data))
    }
    useEffect(()=>{
        getTerminals();
    },[Value])
 
    return <>
    <div className={S.SingleDamCon}>
        <div className={W.TabForAllAnnimbtnLICon}>
            {a.map((item,index)=>{
              return <div key={index} className={`${W.jobbtnLItab} ${index === Value && W.ActiveLITab}`} onClick={()=>setValue(index)} >{item.comp}</div>
              

            })}
          </div>
        {!currentTheme&&<div className={W.AnimContentLI}>
        {currentTerminals.length?<table >
            <thead>
            <tr>
            
                
                    
                    <th className={S.LogoFormT}><div><span><Sensors/></span></div></th>
                    
                    <th className={S.LogoFormT}><div><span>
                    <FmdGoodIcon/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <Home/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <AccessTimeIcon/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <InfoIcon/></span></div></th>

                </tr>
            </thead>
            <tbody style={{margin:'0px auto'}}>
                
                <tr>
                    
                    
                    
                    <td className={S.TableFormTit}>کد دستگاه </td>
                    
                    <td className={S.TableFormTit}>مختصات </td>
                    <td className={S.TableFormTit}>دامداری </td>
                    <td className={S.TableFormTit}>زمان ایجاد </td>
                    <td className={S.TableFormTit}> جزئیات </td>

                </tr>
                {currentTerminals.map((item,index)=>{
                    return <tr key={index}>
                    <td>{item?.deviceCode}</td>
                    <td>{item?.installedLocation}</td>
                    <td>{item?.farmName}</td>
                    <td>{item&&moment(item.createAt&&item?.createAt).format('jYYYY-jMM-jDD HH:mm')}</td>
                    <td className={E.DetIc}><Link onClick={()=>{
                        changeFarm(item.farmId)
                      }} to={`/Terminals/${item?.id}`}>
                    <div className='btnCardDAm'> مشاهده</div>

                      </Link></td>

                </tr>
                })}
               
            </tbody>
        </table>:<EmptyReturn/>}
        </div>}
        {currentTheme&&<TerminalList data={currentTerminals}/>}
        
        
            


    </div>
    
    </>
}

export default TerminalsComp